// extracted by mini-css-extract-plugin
export default {"sidebar":"f04hA"};